import { editorModel } from '#packages/util';

import { MIGRATION_FLOWS } from './constants';
import { initAfterSectionMigrationDone } from './api/runAfterSectionsMigration';

import type { Scope } from './scope';
import type { MigrationFlow } from './types';

function resolveMigrationFlow(scope: Scope): MigrationFlow | undefined {
  const { isInsideEditorX, isInsideAppStudio } = scope.editorParamsAPI;

  if (isInsideEditorX || isInsideAppStudio || editorModel.isImpersonated) {
    return;
  }

  return MIGRATION_FLOWS.SECTIONS_MIGRATION;
}

export async function initMigration(scope: Scope) {
  if (process.env.NODE_ENV === 'test') {
    return;
  }
  const migrationFlow = resolveMigrationFlow(scope);

  if (!migrationFlow) {
    scope.migrationHook.resolve();
    return;
  }

  scope.migrationService.setFlow(migrationFlow);

  if (migrationFlow === MIGRATION_FLOWS.SECTIONS_MIGRATION) {
    await initAfterSectionMigrationDone(scope);
  }
}
